import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemModel } from '../models/nav-item.model';

@Pipe({
  name: 'filterFavouriteSubmenu',
  standalone: true,
})
export class FilterFavouriteSubmenuPipe implements PipeTransform {
  transform(favouriteSubmenu: MenuItemModel | null, selectedNavItemUrl: string): MenuItemModel | null {
    if (!favouriteSubmenu || !selectedNavItemUrl) return null;

    const getNavRoot = (link?: string): string => (link ?? '').replace(/^\/+/, '').split('/')[0].trim();
    const filteredItems = (favouriteSubmenu.items ?? []).filter(
      ({ routerLink }) => getNavRoot(routerLink) === selectedNavItemUrl,
    );

    return filteredItems.length ? new MenuItemModel({ ...favouriteSubmenu, items: filteredItems }) : null;
  }
}
